<div class="custom-snackbar">
    <div class="content">
      <h4>{{ data.title }}</h4>
      <p [class.small-font]="titleOnly">{{ data.message }}</p>
    </div>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
